import { AppRouter } from '@/app/router';

export function App() {
  return <AppRouter />;
}
